import AdminStore from './storeAdmin'
import AdminUIStore from './storeUIAdmin'
import Store from './store'
import UI from './ui'
import LehrplanStore from './lehrplan'
import NewExampleFormStore from './newexampleform'
import NewCollectionFormStore from './newcollectionform'
import MessengerStore from './messenger'

const store = new Store()

export default {
  admin: new AdminStore(),
  adminui: new AdminUIStore(),
  store: store,
  ui: new UI(store),
  lehrplanstore: new LehrplanStore(),
  newexampleformstore: new NewExampleFormStore(),
  newcollectionformstore: new NewCollectionFormStore(),
  messenger: new MessengerStore()
}



// WEBPACK FOOTER //
// ./src/stores/storeHolder.js